<svg
  [attr.height]="height"
  [attr.width]="width"
  class="sparkles-icon"
  fill="currentColor"
  viewBox="0 4 64 64"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M22.625 2c0 15.834-8.557 30-20.625 30 12.068 0 20.625 14.167 20.625 30 0-15.833 8.557-30 20.625-30-12.068 0-20.625-14.166-20.625-30M47 32c0 7.918-4.277 15-10.313 15C42.723 47 47 54.084 47 62c0-7.916 4.277-15 10.313-15C51.277 47 47 39.918 47 32zM51.688 2c0 7.917-4.277 15-10.313 15 6.035 0 10.313 7.084 10.313 15 0-7.916 4.277-15 10.313-15-6.036 0-10.313-7.083-10.313-15"
  />
</svg>
